var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "switchAccModal modal fade",
        attrs: { id: "switchAccountModal", role: "dialog" },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-lg" },
          [
            _c("div", { staticClass: "modal-content modal_wrapper" }, [
              _c(
                "div",
                { staticClass: "modal-header switchAccountModal-bgcolor" },
                [
                  _c(
                    "div",
                    { staticClass: "header-close-icon" },
                    [
                      _c("base-icon", {
                        staticClass: "icon-close",
                        attrs: {
                          "data-v-34da9296": "",
                          icon: "close_icon",
                          "data-toggle": "modal",
                          "data-target": "#switchAccountModal",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._m(0),
                ]
              ),
              _c("div", { staticClass: "modal-body" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 switchAccount-search-input",
                  },
                  [
                    _c("search-box", {
                      model: {
                        value: _vm.searchText,
                        callback: function ($$v) {
                          _vm.searchText = $$v
                        },
                        expression: "searchText",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "col-xs-12 activity-tracker-tabs" }, [
                  _c("div", { staticClass: "containers" }, [
                    _c(
                      "div",
                      {
                        staticClass: "scroller scroller-left p-0",
                        on: {
                          click: function ($event) {
                            return _vm.leftScroll()
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "left-arrow cursor-pointer image-size",
                          attrs: {
                            src: "/static/images/icons/chevron_left.svg",
                            alt: "",
                          },
                        }),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "scroller scroller-right p-0",
                        on: {
                          click: function ($event) {
                            return _vm.rightScroll()
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "right-arrow cursor-pointer image-size",
                          attrs: {
                            src: "/static/images/icons/chevron_right.svg",
                            alt: "",
                          },
                        }),
                      ]
                    ),
                    _c("div", { staticClass: "tabs-left" }, [
                      _c(
                        "ul",
                        {
                          staticClass: "nav nav-tabs list",
                          attrs: { role: "tablist" },
                        },
                        [
                          _c(
                            "li",
                            {
                              staticClass: "nav-item",
                              class: { active: _vm.tabActiveName == "REP" },
                              attrs: { role: "presentation" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "nav-link",
                                  attrs: { role: "tab", "data-toggle": "tab" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.tabClicked("REP")
                                    },
                                  },
                                },
                                [_vm._v("REP")]
                              ),
                            ]
                          ),
                          _c(
                            "li",
                            {
                              staticClass: "nav-item",
                              class: {
                                active: _vm.tabActiveName == "commercial",
                              },
                              attrs: { role: "presentation" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "nav-link",
                                  attrs: { role: "tab", "data-toggle": "tab" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.tabClicked("commercial")
                                    },
                                  },
                                },
                                [_vm._v("Commercial")]
                              ),
                            ]
                          ),
                          _c(
                            "li",
                            {
                              staticClass: "nav-item",
                              class: {
                                active: _vm.tabActiveName == "consulting",
                              },
                              attrs: { role: "presentation" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "nav-link",
                                  attrs: { role: "tab", "data-toggle": "tab" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.tabClicked("consulting")
                                    },
                                  },
                                },
                                [_vm._v("Consulting")]
                              ),
                            ]
                          ),
                          _c(
                            "li",
                            {
                              staticClass: "nav-item",
                              class: { active: _vm.tabActiveName == "emergo" },
                              attrs: { role: "presentation" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "nav-link",
                                  attrs: { role: "tab", "data-toggle": "tab" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.tabClicked("emergo")
                                    },
                                  },
                                },
                                [_vm._v("Emergo")]
                              ),
                            ]
                          ),
                          _c(
                            "li",
                            {
                              staticClass: "nav-item",
                              class: { active: _vm.tabActiveName == "support" },
                              attrs: { role: "presentation" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "nav-link",
                                  attrs: { role: "tab", "data-toggle": "tab" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.tabClicked("support")
                                    },
                                  },
                                },
                                [_vm._v("Support")]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _c(
                  "ul",
                  { staticClass: "col-xs-12" },
                  _vm._l(
                    _vm.switchAccountsListToRender,
                    function (account, indexes) {
                      return _c(
                        "li",
                        {
                          key: indexes,
                          on: {
                            click: function ($event) {
                              return _vm.selectedAccount(account.account_id)
                            },
                          },
                        },
                        [
                          _c("a", { staticClass: "flex" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-9 col-sm-9 default-props font-props",
                                class: {
                                  "highlight-selected":
                                    _vm.selectedAccountId ===
                                    account.account_id,
                                },
                              },
                              [_vm._v(" " + _vm._s(account.account_name) + " ")]
                            ),
                            _c(
                              "div",
                              {
                                ref: account.account_id,
                                refInFor: true,
                                staticClass: "col-xs-3 col-sm-3 default-none",
                                class: {
                                  "display-active":
                                    _vm.selectedAccountId ===
                                    account.account_id,
                                },
                                attrs: { id: account.account_id },
                              },
                              [
                                _c("img", {
                                  staticClass: "img-size fl-rt",
                                  attrs: {
                                    src: "/static/images/icons/check.svg",
                                    alt: "check-icon",
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _c("hr", { staticClass: "box-int-line" }),
                        ]
                      )
                    }
                  ),
                  0
                ),
              ]),
              _c(
                "div",
                { staticClass: "modal-footer switchAccountModal-bgcolor" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "col-xs-5 btn emergo-white-button",
                      attrs: { type: "button", "data-dismiss": "modal" },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "col-xs-5 btn ml-20 emergo-green-button",
                      attrs: {
                        type: "button",
                        disabled: _vm.selectedAccountId === "",
                        "data-dismiss": "modal",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.switchToNewAccount()
                        },
                      },
                    },
                    [_vm._v(" Go ")]
                  ),
                ]
              ),
            ]),
            _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-title header-props" }, [
      _c("div", { staticClass: "col-xs-12 col-sm-12 pd-0" }, [
        _c("div", { staticClass: "col-xs-2 col-sm-2" }, [
          _c("img", {
            staticClass: "img-size",
            attrs: {
              src: "/static/images/icons/switch_account.svg",
              alt: "switch-icon",
            },
          }),
        ]),
        _c("div", { staticClass: "col-xs-10 col-sm-10 acc-pd" }, [
          _vm._v("Choose Account"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }